import { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Card } from '@mui/material';
import Profile from './Profile';
import PasswordChange from './PasswordChange';
import Page from '../../components/Page';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/material';
import ProfileCover from '../User/Profile/ProfileCover';
import ProfileAbout from '../User/Profile/ProfileAbout';
import { useAppSelector } from '../../store';
import { SuperUserRole } from '../../enum';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Grid mt={1}>{children}</Grid>}
    </div>
  );
}

const Index: React.FC = () => {
  const [value, setValue] = useState<number>(0);
  const userProfile = useAppSelector((state) => state.auth.user);
  const isCompanyAdmin = userProfile?.userRole === SuperUserRole.company;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Page title={isCompanyAdmin ? '' : 'Profile'}>
      <Container maxWidth='xl' sx={{ pt: isCompanyAdmin ? 3 : 0 }}>
        {/* Profile Details Section - Hide for Company Admin */}
        {!isCompanyAdmin && (
        <Card
          sx={{
            mb: 3,
              height: 180,
            position: 'relative',
          }}
        >
          <ProfileCover
            myProfile={{
              fullName: `${userProfile.name}`,
              position: userProfile?.userRole || 'Company Admin',
            }}
          />
        </Card>
        )}

        <ProfileAbout
          email={userProfile.email}
          mobileNumber={userProfile.mobileNumber}
          countryCode={userProfile.countryCallingCode}
        />

        {/* Edit Profile Section */}
        <Box
          sx={{
            maxWidth: { xs: 550, sm: 850, md: 1150, lg: 1500 },
            mt: 3,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons={true}
            aria-label='scrollable auto tabs example'
          >
            <Tab label={'Update Profile'} />
            <Tab label={'Change Password'} />
          </Tabs>
        </Box>
        <TabPanel
          value={value}
          index={0}
        >
          <Profile />
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
        >
          <PasswordChange />
        </TabPanel>
      </Container>
    </Page>
  );
};

export default Index;
